export default "__VITE_ASSET__578c3e27__"